import React from 'react'

const Thanks = () => {
  return (
    <div className='bg-gray-100 h-screen'>
    <div className='container w-ull flex flex-col items-center justify-center pt-5'>
        <p className='text-4xl'>Thanks for Ordering</p>
        <p className='text-2xl'>We will deliver you soon</p>
        <p className='text-2xl'>Estimated time 30 minutes</p>
    </div>
      
    </div>
  )
}

export default Thanks
